// @flow

import React from "react";
import { connect } from "react-redux";
import { localize } from "redux-i18n";
import { SelectEmployeeFilter, SelectEmployeeGrid } from "@modules/shared/components";
import actionCreators from "@modules/shared/actionCreator";
import {
  selectEmployeeList,
  selectEmployeeFilters,
  getSelectedEmployee,
} from "@modules/shared/selectors";
import type { PaginatedList } from "@types";
import type { EmployeeType, EmployeeFilter } from "@modules/employee/types";
import type { State } from "@store/reducers";

type OwnProps = $Exact<{
  clientId: number,
  handleSubmit: Function, // Prop added for LinearWizard purposes
  editable: boolean, // Prop added for LinearWizard purposes
}>;

type PropsFromState = $Exact<{
  selectEmployeeList: PaginatedList<EmployeeType>,
  selectEmployeeFilters: EmployeeFilter | Object,
  selectedEmployee: EmployeeType | null,
}>;

type PropsFromDispatch = $Exact<{
  getEmployeesList: typeof actionCreators.GetEmployeesList,
  selectEmployee: typeof actionCreators.SelectEmployee,
}>;

type Props = $Exact<{
  ...OwnProps,
  ...PropsFromState,
  ...PropsFromDispatch,
  ...PropsFromLocalize,
}>;

type StateProp = $Exact<{
  page: number,
}>;
/*
    This is the common form... it was created after someone created non-reusable similar forms...
    It will store its data in state.shared.selectEmployee and if you need something different
    you can rewrite that easily
 */
export class SelectEmployeeStep extends React.Component<Props, StateProp> {
  state = {
    page: 1,
  };

  onChange = ({ formData }: Object) => {
    this.setState({
      ...this.state,
    });
  };

  onSubmit = (event: Object) => {
    event.preventDefault();
    this.props.getEmployeesList({
      filters: this.props.selectEmployeeFilters,
      page: 1,
      clientId: this.props.clientId,
    });
  };

  onReset = () => {
    this.props.getEmployeesList({
      filters: {},
      page: 1,
      clientId: this.props.clientId,
    });
  };

  onPageChange = (page: number) => {
    this.setState({
      page,
    });
    this.props.getEmployeesList({
      clientId: this.props.clientId,
      filters: this.props.selectEmployeeFilters,
      page,
    });
  };

  selectEmployee = (prop: Object) => {
    this.props.selectEmployee(prop);
    this.props.handleSubmit(prop, true);
  };

  render() {
    return (
      <div className="w-100 d-flex flex-column">
        {this.props.editable && (
          <SelectEmployeeFilter
            onChange={this.onChange}
            onSubmit={this.onSubmit}
            onReset={this.onReset}
          />
        )}
        {this.props.editable ? (
          <SelectEmployeeGrid
            selectEmployeeList={this.props.selectEmployeeList}
            currentPage={this.state.page}
            onPageChange={this.onPageChange}
            onSelectEmployee={this.selectEmployee}
            interactiveMode={this.props.editable}
          />
        ) : (
          this.props.selectedEmployee && (
            <SelectEmployeeGrid
              selectedEmployee={this.props.selectedEmployee}
              interactiveMode={false}
              onPageChange={this.onPageChange}
            />
          )
        )}
      </div>
    );
  }
}

const mapStateToProps = (state: State): PropsFromState => ({
  selectEmployeeList: selectEmployeeList(state),
  selectEmployeeFilters: selectEmployeeFilters(state),
  selectedEmployee: getSelectedEmployee(state),
});

const mapDispatchToProps: PropsFromDispatch = {
  getEmployeesList: actionCreators.GetEmployeesList,
  selectEmployee: actionCreators.SelectEmployee,
};

export default connect(mapStateToProps, mapDispatchToProps)(localize()(SelectEmployeeStep));
